import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useHistory, useLocation } from 'react-router-dom';

import styles from './IdentityVerificationPage.module.scss';
import { Input } from '../../components/common/dynamic-form/base/Input/Input';
import { Button } from '../../components/common/dynamic-form/base/Button/Button';
import logo from '../../assets/Icons/yemeksepeti-logo-vendor.png';
import backArrow from '../../assets/Icons/arrow-left.svg';
import { getPhoneNumber } from '../../actions/services';
import { useAppDispatch } from '../../store/hooks';
import { incrementLoadingCount, decrementLoadingCount } from '../../store/globalSlice';

const schema = z.object({
  identityNumber: z.string()
  .nonempty('Bu alan zorunludur.')
  .regex(/^(?:[1-9]\d{9}[02468]|\d{10})$/, 'Geçersiz Vergi Kimlik veya TC Kimlik No')
});

type FormValues = z.infer<typeof schema>;

const IdentityVerificationPage = () => {
  const history = useHistory();
  const location = useLocation();
  const {state} = location as { state: { offerId?: string } };

  const {register, handleSubmit, formState: {errors, isValid}, reset} = useForm<FormValues>({
    resolver: zodResolver(schema),
    mode: 'onChange'
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    reset({identityNumber: ''});
  }, [reset]);

  const onSubmit = async (data: FormValues) => {
    const {identityNumber} = data;
    const offerId = state?.offerId;

    if (offerId && identityNumber) {
      dispatch(incrementLoadingCount());
      try {
        const response = await getPhoneNumber(identityNumber, offerId);
        
        if (response.code === '00') {
          const phoneNumber = response.phoneNumber || '0555*****20';
          history.push('/phone-verification', {
            offerId,
            identityNumber,
            phoneNumber
          });
        }
      } catch (error: any) {
        console.error('İşlem sırasında bir hata oluştu:', error);
      } finally {
        dispatch(decrementLoadingCount());
      }
    } else {
      console.error("Yönlendirme için offerId veya kimlik numarası eksik.");
    }
  };

  return (
      <div className={styles.pageWrapper}>
        <button onClick={() => history.goBack()} className={styles.backButton}>
          <img src={backArrow} alt="Geri" />
        </button>
        <div className={styles.contentBlock}>
          <div className={styles.header}>
            <h1>Kredi Başvurusu</h1>
            <p>Kredi işleminizin güvenli bir şekilde devam edebilmesi için Vergi Kimlik Numarası
              veya TC Kimlik numaranızı girmeniz gerekmektedir.</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.inputWrapper}>
              <Input
                  id="identityNumber"
                  {...register('identityNumber')}
                  error={errors.identityNumber?.message}
                  placeholder="Vergi Kimlik veya TC Kimlik No"
              />
            </div>

            {/* apiError div'i buradan kaldırıldı */}

            <hr className={styles.divider} />

            <div className={styles.footer}>
              <img src={logo} alt="Yemeksepeti" className={styles.logo} />
              <Button
                  type="submit"
                  variant="primary"
                  className={styles.submitBtn}
                  disabled={!isValid}
              >
                Devam Et
              </Button>
            </div>
          </form>
        </div>
      </div>
  );
};

export default IdentityVerificationPage;